import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DataImportDialogComponent} from "../../../../shared/components/data-import-dialog/data-import-dialog.component";

@Component({
  selector: 'app-response-showcase',
  templateUrl: './response-showcase.component.html',
  styleUrls: ['./response-showcase.component.scss']
})
export class ResponseShowcaseComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<DataImportDialogComponent>,
				@Inject(MAT_DIALOG_DATA) public readonly dialogSettings: any) { }

	ngOnInit() {
		console.log(this.dialogSettings)
	}
}
